import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

export type { Category } from './types';

import { LoadingCategories, LoadingInlineCategories } from './LoadingCategories';

export const CategorySelector = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CategorySelector" */ './CategorySelector'))
			.CategorySelector,
	loading: () => <LoadingCategories />,
});

export const InlineCategorySelector = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InlineCategorySelector" */ './InlineCategorySelector'
			)
		).InlineCategorySelector,
	loading: () => <LoadingInlineCategories />,
});
